// extracted by mini-css-extract-plugin
module.exports = {"minHeightTest":"ArticleInjector_minHeightTest__1E8YZ","root":"ArticleInjector_root__8EeBf"};